import { render } from "./DeliveryProductDetail.vue?vue&type=template&id=89ddc764"
import script from "./DeliveryProductDetail.vue?vue&type=script&lang=js"
export * from "./DeliveryProductDetail.vue?vue&type=script&lang=js"

import "./DeliveryProductDetail.vue?vue&type=style&index=0&id=89ddc764&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__